import { render } from "./AdminNewUsers.vue?vue&type=template&id=532d6c50&scoped=true"
import script from "./AdminNewUsers.vue?vue&type=script&lang=js"
export * from "./AdminNewUsers.vue?vue&type=script&lang=js"

import "./AdminNewUsers.vue?vue&type=style&index=0&id=532d6c50&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532d6c50"]])

export default __exports__